import { render, staticRenderFns } from "./CRMLawcaseBaseInfo.vue?vue&type=template&id=bbd983bc&scoped=true&"
import script from "./CRMLawcaseBaseInfo.vue?vue&type=script&lang=js&"
export * from "./CRMLawcaseBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./CRMLawcaseBaseInfo.vue?vue&type=style&index=0&id=bbd983bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd983bc",
  null
  
)

export default component.exports